import { useClearRefinements } from 'react-instantsearch';
import { useTranslation } from 'react-i18next';

import { clearAllQueryParams } from '../unified-search/utils';
import { toggleButton } from '@klv/organisms/unified-search/styles/unified-search.module.css';

import type { IClearAll } from './types';

const ClearAll = ({ refine, searchBox, ...props }: IClearAll) => {
  const { refine: clearRefinements } = useClearRefinements(props);
  const { t } = useTranslation();

  return (
    <button 
    className={toggleButton}
    type="button"
    onClick={() => {
      refine('');
      clearRefinements();
      clearAllQueryParams();
      if (searchBox.current) searchBox.current.value = '';
    }}>
      {t('organisms_whatsNew_clearAll')}
  </button>
  );
};

export default ClearAll;
